var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SquareTag',{attrs:{"size":"small","variant":"orange","light":true}},[_vm._v("\n  ★ Recommended\n")])}
var staticRenderFns = []

export { render, staticRenderFns }